import React from 'react';

import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import {
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';

import addDays from '../../utils/common/addDays';
import Button from '../Button';
import { IconDatePicker } from '../IconDatePicker';

interface DateNavigatorProps {
  onDateChange: (date: dayjs.Dayjs) => void,
  date: dayjs.Dayjs,
  dateIncrement?: number,
  hideDateLabel?: boolean,
}

const DateNavigator = ({
  onDateChange,
  date,
  dateIncrement = 1,
  hideDateLabel = false,
}: DateNavigatorProps) => (
  <Stack direction="row" spacing={1} alignItems="center">
    <Button color="gray" onClick={() => onDateChange(dayjs())} size="small">Today</Button>
    <Stack
      direction="row"
      alignItems="center"
    >
      <IconButton onClick={() => onDateChange(addDays(date, -dateIncrement))}>
        <ChevronLeft />
      </IconButton>
      <IconButton onClick={() => onDateChange(addDays(date, dateIncrement))}>
        <ChevronRight />
      </IconButton>
    </Stack>
    <IconDatePicker
      value={date}
      onChange={(newDate) => onDateChange(newDate ?? dayjs())}
    />
    {!hideDateLabel && <Typography variant="h5">{date.format('dddd D MMM \'YY')}</Typography>}
  </Stack>
);
export default DateNavigator;
